import React from 'react'
import TableContainer from '../containers/TableContainer'

const TablePage = () => (
    <div className="wrapper">
        <TableContainer />
    </div>
)

export default TablePage
